import { useMemo } from 'react';
import { useAuth } from '../context/AuthContext';
import { parseUserPermissions } from '../utils/permissionsUtils';
import {
  PAGE_PERMISSION_IDS,
  SCHEDULE_PERMISSION_IDS,
  canEditPageForUser,
  canViewPageForUser,
  departmentSchedulePageId,
  isDirectorScheduleEditBlocked,
} from '../utils/pagePermissionsLogic';

export { parseUserPermissions } from '../utils/permissionsUtils';
export {
  PAGE_PERMISSION_IDS,
  SCHEDULE_PERMISSION_IDS,
  isDirectorScheduleEditBlocked,
};

/**
 * Хук проверки прав доступа.
 * - admin: полный доступ
 * - director: просмотр всего; редактирование только по permissions.edit (графики — только просмотр)
 * - department_user: свой график по отделу + страницы из permissions
 */
export function usePermissions() {
  const { user } = useAuth();

  return useMemo(() => {
    if (!user) {
      return {
        canView: () => false,
        canEdit: () => false,
        isAdmin: false,
        isDirector: false,
        permissions: { view: [], edit: [] },
        departmentSchedulePageId: null,
      };
    }

    const isAdmin = user.role === 'admin';
    const isDirector = user.role === 'director';
    const deptPage = departmentSchedulePageId(user);
    const perms = parseUserPermissions(user.permissions);

    return {
      canView: (pageId) => canViewPageForUser(user, pageId),
      canEdit: (pageId) => canEditPageForUser(user, pageId),
      isAdmin,
      isDirector,
      permissions: perms,
      departmentSchedulePageId: deptPage,
    };
  }, [user]);
}

/** Удобная обёртка для страниц графиков */
export function useSchedulePermissions(schedulePageId) {
  const { canView, canEdit } = usePermissions();
  return {
    canViewSchedule: canView(schedulePageId),
    canEditSchedule: canEdit(schedulePageId),
  };
}
